import isNotEmpty from "./empty-field";

export default function isApiDataValid(data) {
  return isNotEmpty(data.client_id) &&
    isNotEmpty(data.client_secret) &&
    isNotEmpty(data.grant_type) &&
    isNotEmpty(data.scope);
}
